import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["type", "code", "message"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { GENDER } from "@/lib/constants";
import dayjs from "@/lib/day";
import { AUTH_ERROR_MESSAGES, MY_SKP_LOGIN_REASONS, MY_SKP_RELATION_MESSAGES } from "@/lib/errors";
import { myskpSignupComplete } from "@/lib/mailTemplate";
import MySkpToken from "@/lib/myskpToken";
import sendEmail from "@/lib/sendEmail";
import { gql } from "@apollo/client";
import { UserInputError } from "apollo-server-errors";
import { createToken, sleep } from "./helper";
import Uid2Token from "@/lib/uid2Token";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type MySkpUserAttrs {\n    mailAddress: String\n    first_name: String\n    last_name: String\n    birthday: String\n    sex: String\n  }\n\n  type MySkpAuthError {\n    type: String\n    code: Int\n    message: String\n    token: String\n  }\n\n  type MySkpAuth @cacheControl(maxAge: 0) {\n    token: String\n    user: AccountUser\n    error: MySkpAuthError\n  }\n\n  type MySkpTokenVerifyResult @cacheControl(maxAge: 0) {\n    result: Boolean\n    attrs: MySkpUserAttrs\n  }\n\n  type MySkpRelationResult @cacheControl(maxAge: 0) {\n    auth: MySkpAuth\n    relationResult: Boolean\n    hasContinuousProduct: Boolean\n  }\n\n  type Query {\n    mySkpTokenVerify(token: String!): MySkpTokenVerifyResult\n  }\n\n  type Mutation {\n    mySkpLogin(\n      loginid: String!\n      password: String!\n      signature: String!\n    ): MySkpAuth\n\n    mySkpSignup(\n      token: String!\n      mailAddress: String!\n      password: String!\n      firstName: String!\n      lastName: String!\n      birthday: String!\n      sex: String!\n      terms: String!\n      signature: String!\n    ): MySkpRelationResult\n\n    mySkpRelation(\n      token: String!\n      mailAddress: String!\n      password: String!\n      signature: String!\n    ): MySkpRelationResult\n\n    mySkpRelationAuth(\n      mailAddress: String!\n      password: String!\n    ): MySkpRelationResult\n  }\n"])));
export var resolvers = {
  Query: {
    mySkpTokenVerify: function () {
      var _mySkpTokenVerify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var token, req, res, myskpToken, verified;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                token = _ref.token;
                req = _ref2.req, res = _ref2.res;
                myskpToken = new MySkpToken(req, res);
                _context.next = 5;
                return myskpToken.verify(token);

              case 5:
                verified = _context.sent;

                if (!verified) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", {
                  result: true,
                  attrs: verified
                });

              case 10:
                return _context.abrupt("return", {
                  result: false
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function mySkpTokenVerify(_x, _x2, _x3) {
        return _mySkpTokenVerify.apply(this, arguments);
      }

      return mySkpTokenVerify;
    }()
  },
  Mutation: {
    mySkpLogin: function () {
      var _mySkpLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref3, _ref4) {
        var loginid, password, signature, req, res, dataSources, user, _user$error, type, code, message, attrs, errorResponse, myskpToken, token, _token, uid2, _e$extensions, _e$extensions$respons, _response$error, _response$error2, response;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loginid = _ref3.loginid, password = _ref3.password, signature = _ref3.signature;
                req = _ref4.req, res = _ref4.res, dataSources = _ref4.dataSources;
                _context2.prev = 2;
                _context2.next = 5;
                return dataSources.myskp.login(loginid, password);

              case 5:
                user = _context2.sent;

                if (!user.error) {
                  _context2.next = 13;
                  break;
                }

                _user$error = user.error, type = _user$error.type, code = _user$error.code, message = _user$error.message, attrs = _objectWithoutProperties(_user$error, _excluded);
                errorResponse = {
                  error: {
                    type: type,
                    code: code,
                    message: message
                  }
                };

                if (["need_user_regist", "need_relation"].includes(MY_SKP_LOGIN_REASONS[code])) {
                  // alice_bs_numbersはフロントに返却しないようにする
                  // サーバー側で保管し、OTPを発行する
                  myskpToken = new MySkpToken(req, res);
                  token = myskpToken.publish(_objectSpread({
                    mailAddress: loginid
                  }, attrs));
                  errorResponse.error.token = token;
                }

                return _context2.abrupt("return", errorResponse);

              case 13:
                _context2.next = 15;
                return createToken(req, res, user, signature, false);

              case 15:
                _token = _context2.sent;
                uid2 = new Uid2Token(req, res);
                _context2.next = 19;
                return uid2.getToken();

              case 19:
                return _context2.abrupt("return", {
                  token: _token,
                  user: user.user
                });

              case 20:
                _context2.next = 35;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](2);
                console.log("myskp login auth error", _context2.t0); // console.log(JSON.stringify(e.extentions, null, 2));

                response = _context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_e$extensions = _context2.t0.extensions) === null || _e$extensions === void 0 ? void 0 : (_e$extensions$respons = _e$extensions.response) === null || _e$extensions$respons === void 0 ? void 0 : _e$extensions$respons.body;

                if (!(response && (response === null || response === void 0 ? void 0 : (_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.code) == 10006)) {
                  _context2.next = 30;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["acountlock"]);

              case 30:
                if (!(response && (response === null || response === void 0 ? void 0 : (_response$error2 = response.error) === null || _response$error2 === void 0 ? void 0 : _response$error2.code) == 11005)) {
                  _context2.next = 34;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["myskpSimilarAccount"]);

              case 34:
                throw new UserInputError(AUTH_ERROR_MESSAGES["unauthorized"]);

              case 35:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 22]]);
      }));

      function mySkpLogin(_x4, _x5, _x6) {
        return _mySkpLogin.apply(this, arguments);
      }

      return mySkpLogin;
    }(),
    mySkpSignup: function () {
      var _mySkpSignup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_parent, args, _ref5) {
        var req, res, dataSources, myskpToken, verified, existsUser, user, token, relationResult, agreeTerms, uid2, _e$extensions2, _e$extensions2$respon, _e$extensions3, _e$extensions3$respon, status, body, _body$error;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                req = _ref5.req, res = _ref5.res, dataSources = _ref5.dataSources;
                _context4.prev = 1;
                // alice_bs_numbersを取り出す
                myskpToken = new MySkpToken(req, res);
                _context4.next = 5;
                return myskpToken.verify(args.token);

              case 5:
                verified = _context4.sent;

                if (verified) {
                  _context4.next = 8;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["default"], {
                  invalidArgs: Object.keys(args)
                });

              case 8:
                _context4.next = 10;
                return dataSources.user.existed(args.mailAddress);

              case 10:
                existsUser = _context4.sent;

                if (!existsUser) {
                  _context4.next = 13;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["signup"]);

              case 13:
                _context4.next = 15;
                return dataSources.user.signup(args, {
                  alice_bs_numbers: verified.alice_bs_numbers
                });

              case 15:
                user = _context4.sent;
                _context4.next = 18;
                return createToken(req, res, user, args.signature, false);

              case 18:
                token = _context4.sent;
                _context4.next = 21;
                return sleep(200);

              case 21:
                _context4.next = 23;
                return dataSources.myskp.relation();

              case 23:
                relationResult = _context4.sent;
                // 規約同意
                agreeTerms = args.terms.split(",");
                _context4.next = 27;
                return Promise.all(agreeTerms.map( /*#__PURE__*/function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return dataSources.terms.agree(key);

                          case 2:
                            return _context3.abrupt("return", _context3.sent);

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x10) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 27:
                _context4.next = 29;
                return sendEmail(myskpSignupComplete({
                  address: args.mailAddress,
                  user: user.user
                }, req.adultMode));

              case 29:
                uid2 = new Uid2Token(req, res);
                _context4.next = 32;
                return uid2.getToken();

              case 32:
                return _context4.abrupt("return", {
                  auth: {
                    token: token,
                    user: user.user
                  },
                  relationResult: relationResult.result,
                  hasContinuousProduct: relationResult.my_transition_right_flag
                });

              case 35:
                _context4.prev = 35;
                _context4.t0 = _context4["catch"](1);
                console.log("myskp signup error", _context4.t0);
                status = _context4.t0 === null || _context4.t0 === void 0 ? void 0 : (_e$extensions2 = _context4.t0.extensions) === null || _e$extensions2 === void 0 ? void 0 : (_e$extensions2$respon = _e$extensions2.response) === null || _e$extensions2$respon === void 0 ? void 0 : _e$extensions2$respon.status;
                body = _context4.t0 === null || _context4.t0 === void 0 ? void 0 : (_e$extensions3 = _context4.t0.extensions) === null || _e$extensions3 === void 0 ? void 0 : (_e$extensions3$respon = _e$extensions3.response) === null || _e$extensions3$respon === void 0 ? void 0 : _e$extensions3$respon.body;

                if (status && body) {
                  // status 422 code 10003のエラーはアカウントのユニーク制約に引っかかったもの
                  // 個別にエラーを出すかどうか、安易にエラーをだすとメールアドレスが登録されているかわかってしまう
                  // error code 70000台はAlice関連のエラー
                  console.log(status, body);

                  if (status == 500 && (body === null || body === void 0 ? void 0 : (_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.code) > 70000) {
                    console.log("alice error", status, body);
                  }
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["signup"]);

              case 42:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 35]]);
      }));

      function mySkpSignup(_x7, _x8, _x9) {
        return _mySkpSignup.apply(this, arguments);
      }

      return mySkpSignup;
    }(),
    mySkpRelation: function () {
      var _mySkpRelation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_parent, args, _ref7) {
        var req, res, dataSources, myskpToken, verified, user, token, relationResult, _e$extensions4, _e$extensions4$respon, _response$error3, response;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                req = _ref7.req, res = _ref7.res, dataSources = _ref7.dataSources;
                _context5.prev = 1;
                // alice_bs_numbersを取り出す
                myskpToken = new MySkpToken(req, res);
                _context5.next = 5;
                return myskpToken.verify(args.token);

              case 5:
                verified = _context5.sent;

                if (verified) {
                  _context5.next = 8;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["default"], {
                  invalidArgs: Object.keys(args)
                });

              case 8:
                _context5.next = 10;
                return dataSources.user.login(args.mailAddress, args.password);

              case 10:
                user = _context5.sent;
                _context5.next = 13;
                return createToken(req, res, user, args.signature, false);

              case 13:
                token = _context5.sent;
                _context5.next = 16;
                return sleep(200);

              case 16:
                _context5.next = 18;
                return dataSources.user.updateValues({
                  alice_bs_numbers: verified.alice_bs_numbers
                });

              case 18:
                _context5.next = 20;
                return dataSources.myskp.relation();

              case 20:
                relationResult = _context5.sent;
                return _context5.abrupt("return", {
                  auth: {
                    token: token,
                    user: user.user
                  },
                  relationResult: relationResult.result,
                  hasContinuousProduct: relationResult.my_transition_right_flag
                });

              case 24:
                _context5.prev = 24;
                _context5.t0 = _context5["catch"](1);
                console.log("login auth error", _context5.t0); // console.log(JSON.stringify(e.extentions, null, 2));

                response = _context5.t0 === null || _context5.t0 === void 0 ? void 0 : (_e$extensions4 = _context5.t0.extensions) === null || _e$extensions4 === void 0 ? void 0 : (_e$extensions4$respon = _e$extensions4.response) === null || _e$extensions4$respon === void 0 ? void 0 : _e$extensions4$respon.body;

                if (!(response && (response === null || response === void 0 ? void 0 : (_response$error3 = response.error) === null || _response$error3 === void 0 ? void 0 : _response$error3.code) == 10006)) {
                  _context5.next = 32;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["acountlock"]);

              case 32:
                throw new UserInputError(AUTH_ERROR_MESSAGES["unauthorized"]);

              case 33:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 24]]);
      }));

      function mySkpRelation(_x11, _x12, _x13) {
        return _mySkpRelation.apply(this, arguments);
      }

      return mySkpRelation;
    }(),
    // MyスカパーのIDパスワードで認証して連携する
    mySkpRelationAuth: function () {
      var _mySkpRelationAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_parent, _ref8, _ref9) {
        var mailAddress, password, req, dataSources, relationResult, res, _e$extensions5, _e$extensions5$respon, _response$error4, response, code;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                mailAddress = _ref8.mailAddress, password = _ref8.password;
                req = _ref9.req, dataSources = _ref9.dataSources;
                _context6.prev = 2;
                _context6.next = 5;
                return dataSources.myskp.authRelation(mailAddress, password);

              case 5:
                relationResult = _context6.sent;
                sleep(200);
                _context6.next = 9;
                return dataSources.user.me();

              case 9:
                res = _context6.sent;
                return _context6.abrupt("return", {
                  auth: {
                    token: req.userToken.accessToken,
                    user: res.user
                  },
                  relationResult: relationResult.result,
                  hasContinuousProduct: relationResult.my_transition_right_flag
                });

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](2);
                console.log("myskp auth relation error", _context6.t0);
                response = _context6.t0 === null || _context6.t0 === void 0 ? void 0 : (_e$extensions5 = _context6.t0.extensions) === null || _e$extensions5 === void 0 ? void 0 : (_e$extensions5$respon = _e$extensions5.response) === null || _e$extensions5$respon === void 0 ? void 0 : _e$extensions5$respon.body;
                code = response === null || response === void 0 ? void 0 : (_response$error4 = response.error) === null || _response$error4 === void 0 ? void 0 : _response$error4.code;

                if (![10001, 10002, 10003].includes(response && code)) {
                  _context6.next = 22;
                  break;
                }

                throw new UserInputError(MY_SKP_RELATION_MESSAGES[code]);

              case 22:
                throw new UserInputError(AUTH_ERROR_MESSAGES["unauthorized"]);

              case 23:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 13]]);
      }));

      function mySkpRelationAuth(_x14, _x15, _x16) {
        return _mySkpRelationAuth.apply(this, arguments);
      }

      return mySkpRelationAuth;
    }()
  },
  MySkpUserAttrs: {
    sex: function sex(attrs) {
      return Object.keys(GENDER).find(function (v) {
        return GENDER[v] === attrs.sex;
      }) || "unknown";
    },
    birthday: function birthday(attrs) {
      var birthday = dayjs(attrs.birthday);

      if (attrs.birthday && attrs.birthday.length > 0 && birthday.isValid()) {
        return birthday.format("YYYY-MM-DD");
      } else {
        return null;
      }
    }
  }
};